import { Component, Input } from '@angular/core';
import { SLEntity, SLEntityOwnedShareItem } from '../entity';
import { Router } from '@angular/router';
import { lessThanZero } from '../utils';

@Component({
  selector: 'sl-entity-shareholders',
  templateUrl: './entity-shareholders.component.html',
})
export class SLEntityShareholdersComponent {

  @Input()
  entity: SLEntity

  @Input()
  canNavigate: boolean = true

  negative = lessThanZero

  constructor(
    private router: Router,
  ) { }

  showEntity(share: SLEntityOwnedShareItem) {
    if (this.canNavigate) {
      this.router.navigate(['shares-ledger', 'entities', share.id]);
    }
  }
}
